import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Input
} from '@angular/core';

import * as Swiper from 'swiper/dist/js/swiper.js';

import { ButtonsService } from '../buttons.service';
import { ResponsiveService } from '../../responsive/responsive.service';
import { ButtonModel } from '../models/button.model';
import { Subscription, BehaviorSubject } from 'rxjs';
import { UserModel } from '../../auth/models/user.model';
import { AuthService } from '../../auth/auth.service';
import { AppState } from '../../app.service';
import { ModalComponent } from '../../global/modal/modal.component';

@Component({
  styleUrls: ['../buttons.scss', './myButtons.component.scss'],
  templateUrl: './myButtons.component.html'
})
export class ButtonsMyComponent implements OnInit, OnDestroy, AfterViewInit {
  private _scrollToLastBoughtButton = false;
  private sliderBreakpoint: number = 768;
  public hasPaidButtons: boolean = false;
  public greetingsMessage: string = '';
  public giverFirstName: string = '';
  public giverLastName: string = '';

  private responsiveSub: Subscription;
  private myButtonsSub: Subscription;

  private buttonsSwiper;
  private buttonsPaginationSwiper;

  public buttons: ButtonModel[];

  public user: UserModel;

  @ViewChild('buttonsSwiper')
  public buttonsSwiperElement: ElementRef;

  @ViewChild('buttonsPaginationSwiper')
  public buttonsPaginationSwiperElement: ElementRef;
  
  @ViewChild('modalComponentElement')
  public modalComponentElement: ModalComponent;

  @Input()
  public stateParams;

  constructor(
    private buttonsService: ButtonsService,
    private responsiveService: ResponsiveService,
    private authService: AuthService,
    private appState: AppState
  ) {
  }

  private createSliders(): void {
    if (this.buttonsSwiperElement) {
      if (!this.buttonsSwiper) {
        this.buttonsSwiper = new Swiper(this.buttonsSwiperElement.nativeElement, {
          spaceBetween: 10,
          simulateTouch: false,
          allowTouchMove: false
        });
      }

      if (!this.buttonsPaginationSwiper) {
        this.buttonsPaginationSwiper = new Swiper(this.buttonsPaginationSwiperElement.nativeElement, {
          spaceBetween: 10,
          slidesPerView: 3,
          centeredSlides: true
        });

        this.buttonsPaginationSwiper.on('slideChange', () => {
          this.buttonsSwiper.slideTo(this.buttonsPaginationSwiper.activeIndex);
        });
      }
    }

    if (this._scrollToLastBoughtButton) {
      this.slideTo(this.buttons.length -1);
    }
  }

  private _doScrollToLastBoughtButton(): void {
    const lastButtonSlide: HTMLElement = document.querySelector('.swiper-slide:last-of-type');

    if (lastButtonSlide !== null) {
      const lastButtonSlideImage: HTMLImageElement = lastButtonSlide.querySelector('img');
      let intervalCounter = 0;

      const loadLastButtonSlideImgInterval = setInterval(() => {
        if (lastButtonSlideImage.complete) {
          clearInterval(loadLastButtonSlideImgInterval);
          window.scrollTo(0, lastButtonSlide.offsetTop);
        } else if (intervalCounter > 25) {
          clearInterval(loadLastButtonSlideImgInterval);
        }

        intervalCounter++;
      }, 100);
    }
  }

  private destroySliders(): void {
    if (this.buttonsSwiper) {
      this.buttonsSwiper.destroy(true, true);
      this.buttonsSwiper = null;
    }

    if (this.buttonsPaginationSwiper) {
      this.buttonsPaginationSwiper.destroy(true, true);
      this.buttonsPaginationSwiper = null;
    }

    if (this._scrollToLastBoughtButton) {
      this._doScrollToLastBoughtButton();
    }
  }

  public ngOnInit() {
    document.getElementsByTagName('body')[0].classList.add('bg-buttons-listing');

    if (typeof this.stateParams.scrollToLastBoughtButton !== 'undefined') {
      this._scrollToLastBoughtButton = this.stateParams.scrollToLastBoughtButton
    }

    this.user = this.authService.currentUser;

    this.myButtonsSub = this.buttonsService.getMine()
      .subscribe(
        (results) => {
          this.buttons = results;

          setTimeout(() => {
            if (this.responsiveService.windowWidth < this.sliderBreakpoint) {
              this.createSliders();
            } else {
              if (this._scrollToLastBoughtButton) {
                this._doScrollToLastBoughtButton();
              }
            }
          });

          this.appState.set('loading', false);
          
          this.buttons.forEach((button) => {
            if (this.hasPaidButtons === true) {
              return;
            }
            
            this.hasPaidButtons = !button.gotByVoucher;
          });
        }
      );

    this.responsiveSub = this.responsiveService.resize
      .subscribe(
        (result) => {
          if (result.width < this.sliderBreakpoint) {
            this.createSliders();
          } else {
            this.destroySliders();
          }
        }
      );
  }

  public ngOnDestroy() {
    document.getElementsByTagName('body')[0].classList.remove('bg-buttons-listing');

    this.responsiveSub.unsubscribe();
    this.myButtonsSub.unsubscribe();
  }

  public ngAfterViewInit() {
    return;
  }

  public slideTo(index: number) {
    if (this.buttonsSwiper && this.buttonsPaginationSwiper) {
      this.buttonsSwiper.slideTo(index);
      this.buttonsPaginationSwiper.slideTo(index);
    }
  }
  
  public openGreetingsMessageModal(greetingsMessage: string, giverFirstName: string, giverLastName: string) {
    this.giverFirstName = giverFirstName;
    this.giverLastName = giverLastName;
    this.greetingsMessage = greetingsMessage;
    this.modalComponentElement.openModal();
  }
  
  public getDataToShare(button: ButtonModel) {
    return {
      image: button.getSpiritualImageUrl(),
      title: 'Mut zur Phantasie',
      copy: `Das ist mein Knopf für mehr ${button.spiritualText}. Wofür steht Deiner?`,
      buttonCode: button.code,
      buttonHtmlLink: `${button.code}`,
      shareAButton: true
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/buttons/myButtons/myButtons.component.ts